import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';

export const fetchMeals = createAsyncThunk(
  'meals/fetchMeals',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/meals/`,);
      return response.data;
    } catch (error) {
      // console.error('Fetch meals error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to fetch meals.');
    }
  }
);

export const addMeal = createAsyncThunk(
  'meals/addMeal',
  async (mealData, { rejectWithValue }) => {
    try {
      const response = await api.post(`/api/meals/`, mealData, );
      return response.data;
    } catch (error) {
      // console.error('Add meal error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to add meal.');
    }
  }
);

export const deleteMeal = createAsyncThunk(
  'meals/deleteMeal',
  async (mealID, { rejectWithValue }) => {
    try {
      await api.delete(`/api/meals/${mealID}/`,);
      return mealID;
    } catch (error) {
      // console.error('Delete meal error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to delete meal.');
    }
  }
);

export const updateMeal = createAsyncThunk(
  'meals/updateMeal',
  async ({ mealID, mealData }, { rejectWithValue }) => {
    try {
      
      const response = await api.put(`/api/meals/${mealID}/`, mealData, );
      return response.data;
    } catch (error) {
      // console.error('Update meal error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to update meal.');
    }
  }
);

// Δημιουργία του Slice
const mealsSlice = createSlice({
  name: 'mealDetails',
  initialState: {
    meals: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeals.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMeals.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.meals = action.payload;
      })
      .addCase(fetchMeals.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch meals.';
      })
      .addCase(addMeal.fulfilled, (state, action) => {
        state.meals.push(action.payload);
      })
      .addCase(addMeal.rejected, (state, action) => {
        state.error = action.payload || 'Failed to add meal.';
      })
      .addCase(deleteMeal.fulfilled, (state, action) => {
        state.meals = state.meals.filter(meal => meal.id !== action.payload);
      })
      .addCase(deleteMeal.rejected, (state, action) => {
        state.error = action.payload || 'Failed to delete meal.';
      })
      .addCase(updateMeal.fulfilled, (state, action) => {
        const index = state.meals.findIndex(meal => meal.id === action.payload.id);
        if (index !== -1) {
          state.meals[index] = action.payload;
        }
      })
      .addCase(updateMeal.rejected, (state, action) => {
        state.error = action.payload || 'Failed to update meal.';
      });
  }
});

export default mealsSlice.reducer;
